var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarfull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 22.5,
    transform: "translate(0 0.25)",
    fill: "#437DC0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.6356L14.6719 14.7193L16.1016 19.375L11.25 15.6356ZM19.125 9.61792H13.1016L11.25 3.625L9.39844 9.61792H3.375L8.25 13.3325L6.39844 19.3255L11.2734 15.6108L14.2734 13.3325L19.125 9.61792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarfull);
export default __webpack_public_path__ + "static/media/starfull.c72334610eeab9eb6d820cc3f93fd32f.svg";
export { ForwardRef as ReactComponent };